import { IUser } from "utils/model/User";

export function Creator(user: IUser) {
  return [1, 2, 3].includes(Number(user.role.id));
}

export function Viewer(user: IUser) {
  return [1, 2, 3].includes(Number(user.role.id));
}
